import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const Heading = styled.h2`
  margin-bottom: 15px;
  text-align: center;
`;

const SubHeading = styled.h3`
  margin-top: 20px;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  margin-bottom: 10px;
  line-height: 1.6;
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 15px;
`;

const ListItem = styled.li`
  margin-bottom: 5px;
`;

const LinkList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-left: 20px;
  margin-bottom: 15px;

  a{
  color: ${({ theme }) => theme.headerText };}
`;

const Strong = styled.strong`
  font-weight: bold;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  margin-bottom: 30px;
`;

const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1.5em auto;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1);
`;

const TemplateFieldsTable = ({ title, fields }) => (
  <Section>
    <SubHeading>{title}</SubHeading>
    <Table>
      <thead>
        <tr>
          <Th>Column #</Th>
          <Th>Classify Field Setup</Th>
          <Th>Target Field Category</Th>
          <Th>Target Column Type</Th>
          <Th>Target Column Name</Th>
          <Th>Source Column Name</Th>
          <Th>Column Not Used</Th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <tr key={index}>
            <Td>{field.column_number}</Td>
            <Td>{field.target_column_classify_field_setup}</Td>
            <Td>{field.target_field_category}</Td>
            <Td>{field.target_column_type}</Td>
            <Td>{field.target_column_name}</Td>
            <Td>{field.source_column_name}</Td>
            <Td>{field.column_not_used}</Td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Section>
);

const Mvs2021Content = () => {
  const coreTemplateFields = [
    {
      column_number: 1,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_id',
      source_column_name: 'csb_survey_production_lot_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 2,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_main_id',
      source_column_name: 'cipars_feedlot_code',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 3,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_record_group_id',
      source_column_name: 'csb_record_group_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 4,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_account_id',
      source_column_name: 'csb_account_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 5,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_upload_id',
      source_column_name: 'csb_survey_production_lot_upload_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 6,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_template_id',
      source_column_name: 'csb_pl_template_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 7,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_production_lot_code',
      source_column_name: 'feedlot_lot_name',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 8,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_sex_id',
      source_column_name: 'sex',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 9,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_steers',
      source_column_name: 'csb_pl_sex_percent_steers',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 10,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_cows',
      source_column_name: 'csb_pl_sex_percent_cows',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 11,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_heifers',
      source_column_name: 'csb_pl_sex_percent_heifers',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 12,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_bulls',
      source_column_name: 'csb_pl_sex_percent_bulls',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 13,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_animal_age_category_id',
      source_column_name: 'type_uk',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 14,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_calves',
      source_column_name: 'csb_pl_percent_calves',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 15,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_yearlings',
      source_column_name: 'csb_pl_percent_yearlings',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 16,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_adults',
      source_column_name: 'csb_pl_percent_adults',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 17,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_origin_id',
      source_column_name: 'origin',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 18,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_auction',
      source_column_name: 'csb_pl_origin_percent_auction',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 19,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_backgrounded',
      source_column_name: 'csb_pl_origin_percent_backgrounded',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 20,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_ranch_direct',
      source_column_name: 'csb_pl_origin_percent_ranch_direct',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 21,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_brd_risk_id',
      source_column_name: 'brd_risk_category',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 22,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_low',
      source_column_name: 'csb_pl_brd_risk_percent_low',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 23,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_medium',
      source_column_name: 'csb_pl_brd_risk_percent_medium',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 24,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_high',
      source_column_name: 'csb_pl_brd_risk_percent_high',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 25,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_quarter_of_year_closeout_id',
      source_column_name: 'closeout',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 26,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_in',
      source_column_name: 'hd_in',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 27,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_railed',
      source_column_name: 'railed',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 28,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_dead',
      source_column_name: 'deaths',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 29,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_slaughtered',
      source_column_name: 'hd_out',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 30,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_weight_in_units_id',
      source_column_name: 'csb_pl_source_weight_in_units_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 31,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_weight_in_value',
      source_column_name: 'csb_pl_source_weight_in_value',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 32,
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_avg_weight_in_kgs',
      source_column_name: 'avg_in_weight_kg',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 33,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_weight_out_units_id',
      source_column_name: 'csb_pl_source_weight_out_units_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 34,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_weight_out_value',
      source_column_name: 'csb_pl_source_weight_out_value',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 35,
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_avg_weight_out_kgs',
      source_column_name: 'avg_out_weight_kg',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 36,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'date',
      target_column_name: 'csb_pl_avg_date_in',
      source_column_name: 'avg_in_date',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 37,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'date',
      target_column_name: 'csb_pl_avg_date_out',
      source_column_name: 'avg_out_date',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 38,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_total_days_on_feed',
      source_column_name: 'dof',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 39,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_total_head_days',
      source_column_name: 'head_days',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 40,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_notes',
      source_column_name: 'csb_pl_notes',
      column_not_used: 'Not Used (1)',
    },
  ];

  const feedDrugTemplateFields = [
    {
      column_number: 1,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_drug_id',
      source_column_name: 'lot_code',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 2,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_id',
      source_column_name: 'csb_survey_production_lot_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 3,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_main_id',
      source_column_name: 'csb_survey_main_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 4,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_record_group_id',
      source_column_name: 'csb_record_group_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 5,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_account_id',
      source_column_name: 'csb_account_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 6,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_upload_id',
      source_column_name: 'csb_survey_production_lot_upload_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 7,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_template_id',
      source_column_name: 'csb_pl_template_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 8,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_ordinal',
      source_column_name: 'csb_pl_drug_ordinal',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 9,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_route_id',
      source_column_name: 'route',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 10,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(192)',
      target_column_name: 'csb_pl_source_drug_name',
      source_column_name: 'antibiotic',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 11,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_drug_value',
      source_column_name: 'kg_used',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 12,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      source_column_name: 'unit',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 13,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Trade Name (2)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_trade_name_id (TnId=)',
      source_column_name: 'csb_pl_drug_trade_name_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 14,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Active Ingredient (1)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_active_ingredient_id (AiId=)',
      source_column_name: 'antibiotic',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 15,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_mg',
      source_column_name: 'kg_used',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 16,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_ml',
      source_column_name: 'csb_pl_drug_total_ml',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 17,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_id',
      source_column_name: 'csb_pl_drug_regimen_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 18,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_detail_id',
      source_column_name: 'csb_pl_drug_regimen_detail_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 19,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      source_column_name: 'reason',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 20,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 21,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 22,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 23,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      source_column_name: 'indication',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 24,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      source_column_name: 'csb_pl_drug_secondary_reason_digestive',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 25,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      source_column_name: 'csb_pl_drug_secondary_reason_lameness',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 26,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      source_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 27,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
      source_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 28,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
      source_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 29,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_enteritis',
      source_column_name: 'csb_pl_drug_secondary_reason_enteritis',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 30,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      source_column_name: 'csb_pl_drug_secondary_reason_mixed',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 31,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      source_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 32,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_other',
      source_column_name: 'csb_pl_drug_secondary_reason_other',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 33,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_other_description',
      source_column_name: 'csb_pl_drug_secondary_reason_other_description',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 34,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_secondary_reason_source',
      source_column_name: 'indication',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 35,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_notes',
      source_column_name: 'csb_pl_drug_notes',
      column_not_used: 'Not Used (1)',
    },
  ];

  const injectableDrugTemplateFields = [
    {
      column_number: 1,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_drug_id',
      source_column_name: 'lot_code',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 2,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_id',
      source_column_name: 'csb_survey_production_lot_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 3,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_main_id',
      source_column_name: 'csb_survey_main_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 4,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_record_group_id',
      source_column_name: 'csb_record_group_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 5,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_account_id',
      source_column_name: 'csb_account_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 6,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_upload_id',
      source_column_name: 'csb_survey_production_lot_upload_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 7,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_template_id',
      source_column_name: 'csb_pl_template_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 8,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_ordinal',
      source_column_name: 'csb_pl_drug_ordinal',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 9,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_route_id',
      source_column_name: 'route',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 10,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(192)',
      target_column_name: 'csb_pl_source_drug_name',
      source_column_name: 'antibiotic',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 11,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_drug_value',
      source_column_name: 'ml_used',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 12,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      source_column_name: 'unit',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 13,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Trade Name (2)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_trade_name_id (TnId=)',
      source_column_name: 'csb_pl_drug_trade_name_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 14,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Active Ingredient (1)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_active_ingredient_id (AiId=)',
      source_column_name: 'antibiotic',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 15,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_mg',
      source_column_name: 'csb_pl_drug_total_mg',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 16,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_ml',
      source_column_name: 'ml_used',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 17,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_id',
      source_column_name: 'csb_pl_drug_regimen_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 18,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_detail_id',
      source_column_name: 'csb_pl_drug_regimen_detail_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 19,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      source_column_name: 'reason',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 20,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 21,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 22,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 23,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      source_column_name: 'indication',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 24,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      source_column_name: 'csb_pl_drug_secondary_reason_digestive',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 25,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      source_column_name: 'csb_pl_drug_secondary_reason_lameness',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 26,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      source_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 27,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
      source_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 28,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
      source_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 29,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_enteritis',
      source_column_name: 'csb_pl_drug_secondary_reason_enteritis',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 30,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      source_column_name: 'csb_pl_drug_secondary_reason_mixed',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 31,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      source_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 32,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_other',
      source_column_name: 'csb_pl_drug_secondary_reason_other',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 33,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_other_description',
      source_column_name: 'csb_pl_drug_secondary_reason_other_description',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 34,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_secondary_reason_source',
      source_column_name: 'indication',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 35,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_notes',
      source_column_name: 'csb_pl_drug_notes',
      column_not_used: 'Not Used (1)',
    },
  ];

  return (
    <Container>
      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Metzger Veterinary Services (MVS)
          <br />
          Data Source Information
        </Heading>
        <Paragraph>Metzger Veterinary Services (MVS)</Paragraph>
        <Paragraph>Vet: CSBV00005 (5)</Paragraph>
        <Paragraph>Project Year: 2021</Paragraph>
        <Paragraph>The site has six (6) herds reporting for 2021 data. They are:</Paragraph>
        <List>
          <ListItem>CSBH0000034</ListItem>
          <ListItem>CSBH0000035</ListItem>
          <ListItem>CSBH0000037</ListItem>
          <ListItem>CSBH0000038</ListItem>
          <ListItem>CSBH0000039</ListItem>
          <ListItem>CSBH0000040</ListItem>
        </List>

        <Paragraph>Access to previous years documentation click on the appropriate link below:</Paragraph>
        <LinkList>
          <ListItem><Link to="/beef/data-preparation/mvs2019">MVS 2019</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/mvs2020">MVS 2020</Link></ListItem>
        </LinkList>

        <Paragraph>There is 1 spreadsheet of source data provided by the site.</Paragraph>
        <Paragraph>Within the spreadsheet/workbook of source data are 3 worksheets (actually more but original data is available).</Paragraph>
        <Paragraph>Each worksheet contains the data to upload.</Paragraph>
        <Paragraph>Each worksheet represents 1 year of data for all herds.</Paragraph>

        <Paragraph><Strong>MVS source data structure is similar to FHMS data source structure.</Strong></Paragraph>
        <Paragraph>All core production lot data, for all herds are in a single worksheet and no drug data is included.</Paragraph>
        <Paragraph>In the application, for previous uploads, I would add a survey record to include the year and its herd.</Paragraph>
        <Paragraph>At that point we could add the herd's core and associated drug data.</Paragraph>

        <Paragraph>For MVS data we need to make sure we have added all survey records for a specified year for all herds.</Paragraph>
        <Paragraph>The upload process will upload data for all herds at once, not just one herd at a time.</Paragraph>

        <Paragraph>You can check within the source worksheet of core field production lot data for available herds in the data.</Paragraph>
        <Paragraph>To do this copy all the data in the column referring to the survey herd codes.</Paragraph>
        <Paragraph>Next, in a new worksheet, paste the column of herd codes. There are many repeated herd codes.</Paragraph>
        <Paragraph>To see just the unique herd codes, highlight the column of herd codes within the worksheet, click on the menu-item Data, then click on button to "<Strong>Remove Duplicates</Strong>".</Paragraph>
        <Paragraph>You will see the unique herd codes provided the site.</Paragraph>
      </Section>

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Metzger Veterinary Services (MVS)
          <br />
          Data Source Information
        </Heading>
        <Paragraph>MVS has 4 herds. More herds have been assigned but only 4 herds of data collected so far.</Paragraph>
        <Paragraph>Each spreadsheet within a workbook from MVS represents all herds for a specific sampling year.</Paragraph>
        <Paragraph>The core production lot fields resides in 1 worksheet within the workbook.</Paragraph>
        <Paragraph>The drug information for feed fields resides in a worksheet within the workbook.</Paragraph>
        <Paragraph>The drug information for injectable fields resides in a worksheet within the workbook.</Paragraph>
        <Paragraph>There is no drug information for bolus provided for 2019. There may be in the future.</Paragraph>

        <Paragraph><Strong>We need to upload all 3 worksheets before we attempt to integrate the data into production.</Strong></Paragraph>
        <Paragraph>Each worksheet will be checked separately against its corresponding template.</Paragraph>
        <Paragraph>Once checking is completed and all seems well, then we integrate the data.</Paragraph>
        <Paragraph>All 3 uploaded datasets are necessary before the integrations step can take place within the application.</Paragraph>

        <Paragraph>The core data when uploaded will be set to be uploaded as columns and drugs set to be mixed.</Paragraph>
        <Paragraph>In actual fact there is no drug data in the core worksheet. It will in this way cause no problems at upload.</Paragraph>

        <Paragraph><Strong>The drugs are listed as rows, not columns, within the sheet.</Strong></Paragraph>
        <Paragraph>The drugs are set to its specific drug route when being uploaded i.e. Bolus, Feed or Injectable. No need to choose mixed!</Paragraph>

        <Paragraph>Core field data has no drug data in the worksheet.</Paragraph>
        <Paragraph>However, as mentioned above, all herds for MVS for a specific year are available.</Paragraph>
        <Paragraph><Strong>Because of this, make sure you have created a survey record for each herd for the year you are uploading and integrating.</Strong></Paragraph>
        <Paragraph>If it is not done, then we have no way to associate the production lot data with a survey!</Paragraph>
        <Paragraph>During the upload of the spreadsheet into the database, missing or implied core field data is filled in.</Paragraph>

        <Paragraph>The rows of drug data represent 1 drug, usually a product name and active ingredient for 1 drug route.</Paragraph>
        <Paragraph>All drug routes and associated drugs for a production lot are available within the two remaining drug worksheets.</Paragraph>
        <Paragraph>The drug route column is not provided by the source so <Strong>add a column called "drug route" into a drug worksheet.</Strong></Paragraph>
        <Paragraph>When you do this it makes it simpler at upload and integrate time to add information into the final target drug tables.</Paragraph>

        <Paragraph><Strong>There are several extra things you should do in the spreadsheet before uploading the data:</Strong></Paragraph>
        <Paragraph>The <Strong>season</Strong> or "<Strong>Quarter Closeout</Strong>" field is available.</Paragraph>
        <Paragraph>The seasons are defined in the following way:</Paragraph>
        <List>
          <ListItem>Winter &rarr; January 1 thru March 31</ListItem>
          <ListItem>Spring &rarr; April 1 thru June 30</ListItem>
          <ListItem>Summer &rarr; July 1 thru September 30</ListItem>
          <ListItem>Fall &rarr; October 1 thru December 31</ListItem>
        </List>

        <Paragraph>The <Strong>origin</Strong> or "<Strong>Origin</Strong>" field is available.</Paragraph>
        <Paragraph>The seasons are defined in the following way:</Paragraph>
        <List>
          <ListItem>Auction &rarr; Auction Market (1)</ListItem>
          <ListItem>Ranch &rarr; Ranch Direct (2)</ListItem>
          <ListItem>Background &rarr; Backgrounded (3)</ListItem>
          <ListItem>Mix &rarr; Mixed (4)</ListItem>
        </List>

        <Paragraph>The core data includes a column called "<Strong># Dead</Strong>" as well as a column called "<Strong># Railed</Strong>".</Paragraph>
        <Paragraph>The target database does have a field to store the data in column "# Railed".</Paragraph>
        <Paragraph>Three target fields exist to integrate data into: # of animals in, # of animals that died, # of animals out.</Paragraph>
        <Paragraph>After several discussions, it was decided the "<Strong># Railed</Strong>" should be included in the "<Strong># Out</Strong>".</Paragraph>
        <Paragraph><Strong>Because of this a new column is added to the core data called "out_final". The out_final field is calculated as:</Strong></Paragraph>
        <List>
          <ListItem>"# Railed" + "# Out" = "out_final"</ListItem>
        </List>
        <Paragraph>When setting up the template use the "<Strong>out_final</Strong>" column and skip columns "<Strong># In</Strong>" and "<Strong># Out</Strong>".</Paragraph>

        <Paragraph>Before creating and setting up a template, go through all spreadsheets provided from the site.</Paragraph>
        <Paragraph>Collect field names from each site and put them together. Review the field names to make sure they all match. My experience is the field names do not match. To reduce the number of templates to create, get the field names to match. The fields do not need to be in the same order.</Paragraph>

        <Paragraph>The drug worksheets are missing a column to indicate what drug route the data pertains to.</Paragraph>
        <Paragraph>The worksheet data is confounded with drug route, but when integrating the data it will help to have a column to indicate the route.</Paragraph>
        <Paragraph><Strong>I inserted a new empty column after "Lot Code" near the beginning of the worksheet and labelled it "Route".</Strong></Paragraph>
        <Paragraph>In the feed worksheet all cell values are set to "<Strong>Feed</Strong>".</Paragraph>
        <Paragraph>In the injectable worksheet all cell values are set to "<Strong>Injectable</Strong>".</Paragraph>

        <Paragraph>The drug data to be uploaded requires a column to be added by the data preparation people.</Paragraph>
        <Paragraph>The column added is "<Strong>Total quantity of antimicrobial units</Strong>" for the bolus, feed and injectable worksheets.</Paragraph>
        <Paragraph>Each new column has a parent column we use as a guide for the values to insert into the appropriate worksheet.</Paragraph>
        <Paragraph>As an example, for Bolus, the parent column is "<Strong>Total quantity of antimicrobial used in mg</Strong>".</Paragraph>
        <Paragraph>In the new empty column inserted right beside this column add the value "<Strong>mg</Strong>" for all bolus records.</Paragraph>
        <Paragraph>A similar process is used for the feed and injectable worksheets.</Paragraph>
      </Section>

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Metzger Veterinary Services (MVS)
          <br />
          Template Setup Suggestions
        </Heading>
        <Paragraph>A three template setup is used for one or more years batch of data. If Bolus data was available then create 4 templates.</Paragraph>
        <Paragraph>For the current document, we assume place all known drug fields for each drug route resides in a separate specific drug data worksheet.</Paragraph>
        <Paragraph><Strong>No data switches from core field columns to drug fields as rows for the setup of data for this site!</Strong></Paragraph>

        <Paragraph>Three templates are created. The primary, top level template created represents the Core fields.</Paragraph>
        <Paragraph>The secondary, second level child template created represents the Drug fields associated with a Core row of data.</Paragraph>
        <Paragraph>One drug template is required for each drug route, you need to create separate templates for each drug route.</Paragraph>

        <Paragraph>The Core Template is populated from the Target Table from the production lot table (core fields).</Paragraph>
        <Paragraph>The Child Drug Template is populated from the Target Table from the drug table.</Paragraph>

        <Paragraph>When setting up the core template, make sure a field is specified in the worksheet of core data to match the <Strong>csb_survey_main_id</Strong> target field. In this way I can find the correct main id based on herd code.</Paragraph>
        <Paragraph>The source field available for herd code in MVS data is called "<Strong>yard_code</Strong>".</Paragraph>

        <Paragraph><Strong>*** Remember to setup the template so the source field "yard_code" to the target field "csb_survey_main_id" field and set to not used!</Strong></Paragraph>
        <Paragraph><Strong>*** Remember to setup the template so the source fields pertaining to weights as multi-field and make sure to add the fields for the target fields csb_pl_avg_weight_in_kgs and csb_pl_avg_weight_out_kgs. Set associated target fields for source units and source value for the weight in and weight out to be skipped.</Strong></Paragraph>

        <Paragraph>When setting up each drug template, make sure a field is specified in the worksheet of drug data to match the production lot code source field name. I use the unused field <Strong>csb_survey_production_lot_drug_id</Strong> target field.</Paragraph>
        <Paragraph>In this way the production lot code field name is identified.</Paragraph>

        <Paragraph>Similarly for the drug templates, make sure a field is specified in the worksheet of drug data to match the <Strong>csb_survey_production_lot_drug_id</Strong> target field. In this way we can find the correct production lot.</Paragraph>
        <Paragraph>The source drug field available for production lot code in MVS data is called "<Strong>lot_code</Strong>".</Paragraph>

        <Paragraph><Strong>*** Remember to setup the template so the source drug field "lot_code" to the target field "csb_survey_production_lot_drug_id" field and set to not used!</Strong></Paragraph>
        <Paragraph><Strong>*** Remember to do this for each drug route of data provided.</Strong></Paragraph>

        <Paragraph>Here are the typical template settings used for MVS.</Paragraph>
        <List>
          <ListItem><Strong>Name:</Strong> MVS 2021 - Core (79)</ListItem>
          <ListItem><Strong>Level:</Strong> Top Level (1)</ListItem>
          <ListItem><Strong>Type:</Strong> Core (1)</ListItem>
          <ListItem><Strong>Route:</Strong> Multiple Drugs (4)</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1 (1)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Column (2)</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target</ListItem>
        </List>
        <Image src="/images/ss_template_mvs_core_2021.png"/>
      </Section>

      <TemplateFieldsTable
        title="Core Template: Associated Core Template Fields"
        fields={coreTemplateFields}
      />

      <Section>
        <List>
          <ListItem><Strong>Name:</Strong> MVS 2021 - Feed Drugs (80)</ListItem>
          <ListItem><Strong>Level:</Strong> Second Level (2)</ListItem>
          <ListItem><Strong>Type:</Strong> Drug (2)</ListItem>
          <ListItem><Strong>Route:</Strong> Feed (2)</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1 (1)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Row (1)</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target</ListItem>
        </List>
        <Image src="/images/ss_template_mvs_drug_feed_2021.png"/>
      </Section>

      <TemplateFieldsTable
        title="Drug Template: Feed Drug Template Fields"
        fields={feedDrugTemplateFields}
      />

      <Section>
        <List>
          <ListItem><Strong>Name:</Strong> MVS 2021 - Injectable Drugs (81)</ListItem>
          <ListItem><Strong>Level:</Strong> Second Level (2)</ListItem>
          <ListItem><Strong>Type:</Strong> Drug (2)</ListItem>
          <ListItem><Strong>Route:</Strong> Injectable (3)</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1 (1)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Row (1)</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target</ListItem>
        </List>
        <Image src="/images/ss_template_mvs_drug_injectable_2021.png"/>
      </Section>

      <TemplateFieldsTable
        title="Drug Template: Injectable Drug Template Fields"
        fields={injectableDrugTemplateFields}
      />
    </Container>
  );
};

export default Mvs2021Content;